import PendingFeeList from '@/components/PendingFee/PendingFeeList'

// Écran de consultation : rien ne s'y crée ni ne s'y supprime, le cycle mensuel décide.
let PendingFeeRouter = [{
  path: '/pending-fee',
  name: 'PendingFeeList',
  component: PendingFeeList,
  meta: {
    title: 'Frais à facturer',
    requiresAuth: true,
    authorizations: ['location-for-account_index', 'desktop_access']
  }
}]

export default PendingFeeRouter



// WEBPACK FOOTER //
// ./src/components/PendingFee/router.js